<template>
    <div id="select-address">
        <div id="select-address-search">
            <img class="back" src="../../assets/address_back.png" @click="back">
            <input class="search-box"
                    v-model="searchKey"
                    type="search"
                    id="search">
            <button @click="searchByHand">搜索</button>
            <div class="tip-box" id="searchTip"></div>
        </div>

        <el-amap vid="amap" :center="mapCenter" :plugin="plugin" :zoom="12" :zooms="[3,18]" :events="mapEvents" class="amap-box">
            <el-amap-polygon v-for="polygon in polygons" :path="polygon.path" :events="polygon.events" :key="polygon.index" strokeOpacity="0.5" strokeWeight="2" fillOpacity="0.1"></el-amap-polygon>
        </el-amap>

        <div class="select-address-box">
            <div id="select-address-list">
                <div class="all" @click="curId = 0" :class="{'cur':curId===0}">全部</div>
                <div class="all" @click="curId = 1" :class="{'cur':curId===1}">写字楼</div>
                <div class="all" @click="curId = 2" :class="{'cur':curId===2}">小区</div>
                <div class="all" @click="curId = 3" :class="{'cur':curId===3}">学校</div>
            </div>

            <div class="item" v-show="curId===0">
                <ul>
                    <li v-for="(item, index) in allList" :key="index" @click="handleAddress(item)">
                        <p class="name">{{item.name}}</p>
                        <p class="address">{{item.address}}</p>
                    </li>
                </ul>
            </div>
            <div class="item" v-show="curId===1">
                <ul>
                    <li v-for="(item, index) in officeList" :key="index" @click="handleAddress(item)">
                        <p class="name">{{item.name}}</p>
                        <p class="address">{{item.address}}</p>
                    </li>
                </ul>
            </div>
            <div class="item" v-show="curId===2">
                <ul>
                    <li v-for="(item, index) in houseList" :key="index" @click="handleAddress(item)">
                        <p class="name">{{item.name}}</p>
                        <p class="address">{{item.address}}</p>
                    </li>
                </ul>
            </div>
            <div class="item" v-show="curId===3">
                <ul>
                    <li v-for="(item, index) in schoolList" :key="index" @click="handleAddress(item)">
                        <p class="name">{{item.name}}</p>
                        <p class="address">{{item.address}}</p>
                    </li>
                </ul>
            </div>
        </div>

        <base-dialog v-show="messageVisible" :title="title" display="none" width="80%" @close="close" style="z-index: 9999;">
            <p class="dialog-content">该地区不在配送范围内</p>
            <p style="width: 100%; text-align: left">{{ message }}</p>
            <div class="dialog-btn" @click="close">关闭</div>
            <div class="dialog-btn" style="float: right" @click="rest">重新选择</div>
        </base-dialog>
    </div>
</template>

<script>

    window._AMapSecurityConfig = {
        securityJsCode:'ba0232774b1adeda425c36f390da3336',
    };

    import {DistributionList} from "@/api/Distribution";
    import BaseDialog from "@/components/BaseDialog";
    import {AMapManager} from "vue-amap"
    let amapManager=new AMapManager();
    export default {
        name: "SelectAddress",
        components: { BaseDialog},
        data() {
            let self = this;
            return {
                curId: 0,
                distributionList: [],//所有配送中心列表

                title: '提示',
                messageVisible: false,
                message: "微信在线订购系统目前只支持深圳市、佛山市、广州市、清远市、中山市、东莞市部分地区及惠州市部分地区。其他区域将会陆续开放。",

                allList: [],
                officeList: [],
                houseList: [],
                schoolList: [],

                toSearch:false,
                searchKey:'',
                poiPicker:null,
                amapManager,

                address: '',
                map:null,
                mapCenter: [113.307649675,23.1200491021],
                mapEvents: {
                    init: (o) => {
                        // console.log("======init====");
                        self.map=o;
                        let pos = [];
                        //选址
                        AMapUI.loadUI(['misc/PositionPicker'], function(PositionPicker) {
                          let positionPicker = new PositionPicker({
                              mode: 'dragMap',
                              map: o
                          });

                            // console.log("======loadUI====");
                          positionPicker.on('success', function(positionResult){
                              let area =positionResult.regeocode.pois;
                              // console.log("======positionPicker====" + area);
                              self.address = positionResult.regeocode.addressComponent.city + positionResult.regeocode.addressComponent.district;
                              pos=[positionResult.position.lng,positionResult.position.lat];
                              if (JSON.stringify(pos) !== JSON.stringify(self.mapCenter)) {
                                  self.mapCenter = pos;
                              }
                              area.forEach(poi => {
                                  self.allList.push({
                                      name: poi.name,
                                      address: poi.address,
                                      lng: poi.location.lng,
                                      lat: poi.location.lat,
                                  });
                                  if (poi.type.match('写字楼') || poi.name.match('写字楼')) {
                                      self.officeList.push({
                                          name: poi.name,
                                          address: poi.address,
                                          lng: poi.location.lng,
                                          lat: poi.location.lat,
                                      });
                                  }
                                  if (poi.type.match('小区') || poi.name.match('小区')) {
                                      self.houseList.push({
                                          name: poi.name,
                                          address: poi.address,
                                          lng: poi.location.lng,
                                          lat: poi.location.lat,
                                      });
                                  }
                                  if (poi.type.match('学校') || poi.name.match('学校')) {
                                      self.schoolList.push({
                                          name: poi.name,
                                          address: poi.address,
                                          lng: poi.location.lng,
                                          lat: poi.location.lat,
                                      });
                                  }
                              });

                          });
                          positionPicker.start();

                        });


                    },
                    'moveend': () => {
                        //拖拽地图
                        this.allList = [];
                        this.officeList = [];
                        this.houseList = [];
                        this.schoolList = [];
                    },
                },
                plugin: [
                    {
                        pName: 'Geolocation',
                        // zoomToAccuracy: true,
                        // showCircle: false,
                        events: {
                            init(o) {
                                // o 是高德地图定位插件实例
                                o.getCurrentPosition((status, result) => {
                                    // alert('-----定位' + JSON.stringify(result));
                                    if (result && result.position) {
                                        self.mapCenter = [result.position.lng, result.position.lat];
                                    }
                                    self.$nextTick(); //页面渲染好后
                                });
                            },
                            // error(e){
                            //     alert(JSON.stringify(e));
                            // }
                        }
                    },
                    {
                        pName: 'ToolBar',
                        events: {
                        }
                    },
                    {
                        // 搜索
                        pName: 'PlaceSearch',
                        events: {
                            init (o) {
                                // console.log("======address====");
                                self.map=o;
                                self.toSearch=true;
                                AMapUI.loadUI(['misc/PoiPicker'], function(PoiPicker) {
                                    let poiPicker = new PoiPicker({
                                        input: 'search', //输入框id
                                        placeSearchOptions: {
                                            map: o,
                                            pageSize: 10
                                        },//地点搜索配置
                                        suggestContainer:'searchTip',//输入提示显示DOM
                                        searchResultsContainer:'searchTip'//搜索结果显示DOM
                                    });
                                    self.poiPicker=poiPicker;
                                    //监听poi选中信息
                                    poiPicker.on('poiPicked', function(poiResult) {
                                        let source = poiResult.source;
                                        let poi = poiResult.item;
                                        self.address=poi.district;
                                        self.mapCenter=[poiResult.item.location.lng,poiResult.item.location.lat];
                                        if (source !== 'search') {
                                            poiPicker.searchByKeyword(poi.name);
                                        } else {

                                            // self.mapCenter=[poiResult.item.location.lng,poiResult.item.location.lat];
                                            // self.address=poi.district;
                                            poiPicker.clearSearchResults();
                                            self.searchKey="";
                                            self.toSearch=false;
                                        }
                                        let name = poi.name;
                                        let address = poi.address;
                                        if (address) {
                                            address = name;
                                        }
                                        // console.log("======address====" + address);

                                        // let str_d = RegExp(/市/);
                                        // if (str_d.test(name)){
                                        //     console.log('---------str_d');
                                        //     self.address = '';
                                        // }
                                        let item  = {
                                            name: name,
                                            address: address,
                                            lng: poi.location.lng,
                                            lat: poi.location.lat,

                                        };

                                        self.handleAddress(item);
                                    });
                                });
                            },
                        }
                    }
                ],

                polygons: [],
            }
        },

        mounted() {
            this.requestDistributionList();
        },

        methods: {
            searchByHand(){
                if(this.searchKey!==''){
                    this.poiPicker.searchByKeyword(this.searchKey);
                }
            },

            back() {
                this.$router.go(-1);
            },

            close() {
                this.messageVisible = false;
                this.$emit('close');
                this.$router.go(-1);
            },
            rest() {
                this.messageVisible = false;
                this.$emit('close');
            },
            //获取所有配送中心列表
            requestDistributionList() {
                DistributionList()
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.distributionList = [];

                            response.data.forEach((item) => {
                                if (item.coordinates.split(" ").join("").length > 0) {
                                    this.addLocation(item.coordinates);
                                    this.distributionList.push({
                                        id: item.id,
                                        coordinates: item.coordinates,
                                    });
                                }
                            });

                        }
                    })
            },

            addLocation(path){
                let reg=new RegExp('"','g')//g代表全部
                let data = path.replace(reg, "");
                const dataArray = JSON.parse(data);
                let polyponArray = [];
                for (let i = 0; i < dataArray.length; i++) {
                    polyponArray.push(dataArray[i]);
                }
                let polygon = {
                    draggable: false,
                    bubble: true,
                    path: polyponArray,
                };

                this.polygons.push(polygon);

            },

            handleAddress(item) {
                let _that = this;
                let inDcId;
                let address;
                let lngLat = [item.lng,item.lat];
                for(let i=0; i<_that.distributionList.length; i++) {
                    let coordinates =  _that.distributionList[i].coordinates;
                    let data = coordinates.replace(/"/g, "");
                    const dataArray = JSON.parse(data);
                    let inside = _that.inside(lngLat, dataArray);
                    if (inside) {
                        inDcId = _that.distributionList[i].id;
                        address = _that.address + item.name;
                        break;
                    }
                }
                if (!inDcId) {
                    _that.messageVisible = true;
                    return;
                }
                localStorage.setItem('distributionId', inDcId);
                localStorage.setItem('area', address);
                localStorage.setItem('lng', item.lng);
                localStorage.setItem('lat', item.lat);
                _that.$router.go(-1);

            },

            //判断点是否在多边形内
            inside(point, vs) {
                let x = point[0], y = point[1];

                let inside = false;
                for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
                    let xi = vs[i][0], yi = vs[i][1];
                    let xj = vs[j][0], yj = vs[j][1];

                    let intersect = ((yi > y) !== (yj > y))
                        && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
                    if (intersect) inside = !inside;
                }

                return inside;
            },
        },
    }
</script>

<style scoped lang="scss">
    #select-address {
        background: #FFFFFF;
        #select-address-search {
            width: 100%;
            padding: 5px;
            .back {
                float: left;
                margin-top: 10px;
            }
            .search-input {
                border: 1px solid #BDBDBD;
                padding: 10px;
                text-align: left;
                margin-left: 30px;
                border-radius: 5px;
                height: 40px;
                .search-address {
                    margin-left: 10px;
                    border: 0;
                    outline: none;
                }
            }
        }


        .select-address-box {

            #select-address-list {
                height: 40px;
                border-top: 2px solid #BDBDBD;
                border-bottom: 1px solid #BDBDBD;
                line-height: 40px;

                .all {
                    width: 25%;
                    float: left;
                }
            }
            .item {
                /*margin-bottom: 10px;*/
                ul {
                    height: 240px;
                    overflow: scroll;
                    width: 100%;
                }
                li{
                    min-height: 50px;
                    padding: 5px 10px;
                    border-bottom: 1px solid #BDBDBD;
                    text-align: left;
                    font-size: 0.8rem;
                    .name {

                    }
                    .address{
                        font-size: 0.7rem;
                        color: #757575;
                    }

                    p{
                        margin-block-start: 0em;
                        margin-block-end: 0em;
                    }
                }
            }
        }


        .dialog-content {
            color: #ea2d53;
            font-size: 1rem;
            font-weight: bold;
        }

        .dialog-btn {
            float: left;
            color: #ffffff;
            bottom: 0;
            border-radius: 5px;
            width: 45%;
            padding: 10px;
            background: #ea2d53;
            font-size: 1rem;

        }

        .amap-box {
            height: 330px;
        }

        .search-box {
            position: relative;
            height: 30px;
            width: 80%;
            border: 1px solid #BDBDBD;
            z-index: 9999;
            margin-right: 5px;
        }

        .tip-box{
            width: 100%;
            max-height:260px;
            position: absolute;
            top: 40px;
            overflow-y: auto;
            background-color: #fff;
            z-index: 9999;
        }

        .cur {
            color: #ea2d53;
            font-weight: bold;
        }

    }

    @media screen and (max-width: 320px){
        #select-address {

            .select-address-box {
                .item {
                    ul {
                        height: 200px;
                    }
                }
            }

            .amap-box {
                height: 230px;
            }

            .search-box {
                width: 70%;
            }

        }
    }

    @media screen and (min-width: 321px) and (max-width: 375px) {
        #select-address {

            .select-address-box {
                .item {
                    ul {
                        height: 220px;
                    }
                }
            }

            .amap-box {
                height: 300px;
            }

        }
    }

    @media screen and (min-width: 375px) {
        #select-address {

            .select-address-box {
                .item {
                    ul {
                        height: 295px;
                    }
                }
            }

            .amap-box {
                height: 350px;
            }

        }
    }

    @media screen and (min-width: 414px) {
        #select-address {

            .select-address-box {
                .item {
                    ul {
                        height: 350px;
                    }
                }
            }

            .amap-box {
                height: 370px;
            }

        }
    }
</style>